<template>
  <div class="myRegistration">
        <h3 class="containner-title">{{$t("message.invoice_mangement")}}</h3>
        <div class="row justify-content-end pt-2">
          <div class="col-sm-2" style="position: relative;top: -25px;">
            <select
              class="form-select"
              placeholder="year"
              v-model="search.year"
            >
              <option value="" selected>Choose...</option>
              <option v-for="y in listYear" :key="y.year" :value="y.year">{{y.year}}</option>
            </select>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-sm-3">
            <div class="card text-dark bg-light mb-3">
              <div class="card-body" style="border-left: 4px solid #0d6efd;">
                <h5 class="card-title text-primary">ចំណូលសរុប</h5>
                <p class="card-text m-0" style="color: chocolate;">KHR</p>
                <p class="card-text money-text">{{fomartTotal(dashboard.total)}}</p>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
              <div class="card text-dark bg-light mb-3">
                <div class="card-body" style="border-left: 4px solid #6610f2;">
                  <h5 class="card-title" style="color:#6610f2">Credit/Debit Card</h5>
                  <p class="card-text m-0" style="color: chocolate;">KHR</p>
                  <p class="card-text money-text">{{fomartTotal(dashboard.cards)}}</p>
                </div>
              </div>
          </div>
          <div class="col-sm-3">
              <div class="card text-dark bg-light mb-3">
                <div class="card-body" style="border-left: 4px solid #3498DB;">
                  <h5 class="card-title" style="color:#3498DB">ABA PAY</h5>
                  <p class="card-text m-0" style="color: chocolate;">KHR</p>
                  <p class="card-text money-text">{{fomartTotal(dashboard.abapay)}}</p>
                </div>
              </div>
          </div>
          <div class="col-sm-3">
            <div class="card text-dark bg-light mb-3">
              <div class="card-body" style="border-left: 4px solid #E74C3C;">
                <h5 class="card-title" style="color:#E74C3C;">KHQR</h5>
                <p class="card-text m-0" style="color: chocolate;">KHR</p>
                <p class="card-text money-text">{{fomartTotal(dashboard.bakong)}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body border" style="background-color: #f1f1f1;">
            <form class="form" v-on:submit.prevent>
              <div class="row mb-2">
                <div class="col">
                  <label class="form-label">{{$t("message.invoice_number")}}</label>
                  <input type="text" 
                    v-model="search.invoice"
                    class="form-control" 
                    :placeholder="$t('message.invoice_number')" 
                    aria-label="First name">
                </div>
                <div class="col">
                  <label class="form-label">{{$t("message.transaction_id")}}</label>
                  <input type="text" 
                    v-model="search.transaction_id"
                    class="form-control" 
                    :placeholder="$t('message.transaction_id')" 
                    aria-label="Last name">
                </div>
                <div class="col">
                  <label class="form-label">{{$t("message.year")}}</label>
                  <select
                    class="form-select"
                    placeholder="Year"
                    v-model="search.year"
                  >
                     <option value="" selected>Choose...</option>
                    <option v-for="y in listYear" :key="y.year" :value="y.year">{{y.year}}</option>
                  </select>
                </div>
                <div class="col">
                  <label class="form-label">{{$t("message.month")}}</label>
                  <select
                    class="form-select"
                    placeholder="Month"
                    v-model="search.month"
                  >
                    <option value="" selected>Choose...</option>
                    <option value="1">{{$t("message.january")}}</option>
                    <option value="2">{{$t("message.february")}}</option>
                    <option value="3">{{$t("message.march")}}</option>
                    <option value="4">{{$t("message.april")}}</option>
                    <option value="5">{{$t("message.may")}}</option>
                    <option value="6">{{$t("message.june")}}</option>
                    <option value="7">{{$t("message.july")}}</option>
                    <option value="8">{{$t("message.august")}}</option>
                    <option value="9">{{$t("message.september")}}</option>
                    <option value="10">{{$t("message.october")}}</option>
                    <option value="11">{{$t("message.november")}}</option>
                    <option value="12">{{$t("message.december")}}</option>
                  </select>
                </div>
              </div>
             
              <div class="row mb-2">
                <div class="col-12" style="text-align: right;margin-top: 5px;">
                  <!-- <button class="btn btn-dark m-1"><i class="fas fa-print"></i></button> -->
                  <button class="btn btn-success" @click="exportExcel"><i class="fas fa-file-excel"></i> {{$t("message.export")}}</button>
                  <button class="btn btn-primary m-1" @click="loadData"><i class="fas fa-search"></i> {{$t("message.search")}}</button>
                </div>
              </div>
            </form>
        </div>
        <div class="row">
            <label class="text-end fs-5 fw-bold p-2">{{$t("message.total")}}:
              <span class="text-primary">{{listInvoice.length}}</span>
            </label> 
        </div>
        <table class="table table-bordered">
          <thead class="table-dark">
            <tr>
              <th class="align-middle">#</th>
              <th class="align-middle" style="width: 120px;">{{$t("message.invoice_number")}}</th>
              <th class="text-center align-middle">{{$t("message.transaction_id")}}</th>
              <th class="text-center align-middle">{{$t("message.qty")}}</th>
              <th class="text-center align-middle">{{$t("message.amount")}}</th>
              <th class="text-center align-middle">{{$t("message.currency")}}</th> 
              <th class="text-center align-middle">{{$t("message.payment_option")}}</th>
              <th class="text-center align-middle">{{$t("message.paid_date")}}</th>
              <th class="text-center align-middle">{{$t("message.paid_status")}}</th>
              <th class="text-center align-middle">{{$t("message.action")}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in listInvoice" :key="index">
              <td style="vertical-align: middle;width: 30px;">{{index+1}}</td>
              <td style="vertical-align: middle;">{{item.invoice_number}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.transaction_id}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.items.length}}</td>
              <td class="text-center" style="vertical-align: middle;">{{fomartTotal(item.total_amount)}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.currency}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.payment_method}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.paid_at}}</td>
              <td class="text-center" style="vertical-align: middle;">{{item.status ? $t("message.paid"): $t("message.not_piad")}}</td>
              <td class="text-center" style="vertical-align: middle;" >
                 <button type="button" 
                      class="btn btn-primary me-2" 
                      @click="getShow(item)"
                      data-bs-toggle="modal" 
                      data-bs-target="#showDetialInvoice">
                    <i class="fas fa-search"></i>
                  </button>
                <button class="btn btn-dark" @click="goToPrintInvoice(item.transaction_id)"><i class="fas fa-print"></i></button>
                <!-- <router-link class="btn btn-primary" :to="{ name: 'showParticipant' , params:{id:item.id}}"><i class="far fa-edit"></i></router-link> -->
              </td>
            </tr>
          </tbody>
        </table>
        <pagination 
            v-model="search.page" 
            :records="total" 
            :per-page="search.limit" 
            @paginate="setPage($event)"/>

        <!-- Modal -->
        <div class="modal  fade" id="showDetialInvoice" tabindex="-1" aria-labelledby="showDetialInvoiceLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="showDetialInvoiceLabel">Show All Items Detail</h5>
                <button type="button" 
                  class="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close">
                </button>
              </div>
              <div class="modal-body">
                <div class="row pb-4">
                  <div class="col">Invoice Number: {{currentItem.invoice_number}}</div>
                  <div class="col">Transaction id: {{currentItem.transaction_id}}</div>
                  <div class="col">Total: {{currentItem.total_amount + ' ' + currentItem.currency}} </div>
                  <div class="col">Piad At: {{currentItem.paid_at}}</div>
                </div>
                <table class="table table-bordered">
                  <thead class="table-dark">
                    <tr>
                      <th class="align-middle">#</th>
                      <th class="align-middle">ឈ្មោះ/Name</th>
                      <th class="text-center align-middle">ប្រភេទ/Type</th>
                      <th class="text-center align-middle">ចំនួន/Amount</th>
                      <!-- <th class="text-center align-middle">{{$t("message.amount")}}</th>
                      <th class="text-center align-middle">{{$t("message.currency")}}</th> 
                      <th class="text-center align-middle">{{$t("message.payment_option")}}</th>
                      <th class="text-center align-middle">{{$t("message.paid_date")}}</th>
                      <th class="text-center align-middle">{{$t("message.paid_status")}}</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in currentItem.items" :key="index">
                      <td style="vertical-align: middle;width: 30px;">{{index+1}}</td>
                      <td style="vertical-align: middle;">
                        {{item.registration_item.participant.lastname + ' ' + item.registration_item.participant.firstname}} <br>
                        {{item.registration_item.type_business_name}}
                      </td>
                      <td class="text-center" style="vertical-align: middle;">{{item.registration_item.apply_for==1 ? 'NEW' : 'CPE'}}</td>
                      <td class="text-center" style="vertical-align: middle;">{{item.amount + ' ' + item.currency}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import axios from "@/axios";
import Pagination from 'v-pagination-3';
export default {
  data() {
    return {
      search:{page:1,limit:50,invoice:'',transaction_id:'',year:'',month:''},
      dashboard: {total:0,cards:0,abapay:0,bakong:0},
      total:0,
      listYear: [],
      listInvoice: [],
      currentItem: {}
    };
  },
  computed: { 
    fomartTotal(){
        return (n) => {
            return Number((n).toFixed(1)).toLocaleString();
        }
    },
    getBusinessType(){
      return (t) =>{
        switch (t){
            case '1':
            case 1:
                return this.$t("message.stock_business");
            case '2':
            case 2:
                return this.$t("message.derivative_business");
            case '19':
            case 19:
                return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
            case 20:
            case '20':
                return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
            default:
                return t;
        }
      }
    }
  },
  methods: {
    showLoader() {
      return this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        color: "#01B201",
        canCancel: false,
      });
    },
    goToPrintInvoice(v){
        let routeData = this.$router.resolve({name:'printInvoice',params:{transactionId:v}});
        window.open(routeData.href, '_blank');
    },
    async loadDashboard(year){
      const respone = await axios.get(`year-dashboard-invoice/${year}`, {
        headers: {
          Authorization: `Bearer ${this.$store.getters.getAuthToken}`
        }
      });
      if (respone.status == 200) {
        this.dashboard = respone.data.data;
        console.log('dashboard:',this.dashboard);
      }
    },
    async loadyear(){
      const respone = await axios.get("list-year-invoice", {
        headers: {
          Authorization: `Bearer ${this.$store.getters.getAuthToken}`
        }
      });
      if (respone.status == 200) {
        this.listYear = respone.data.data;
        this.search.year = this.listYear[0].year;
        this.loadDashboard(this.listYear[0].year);
        this.loadData();
      }
    },
    async loadData(){
      let loader = this.showLoader();
      const respone = await axios.get("query-invoice", {
        params: this.search,
        headers: {
          Authorization: `Bearer ${this.$store.getters.getAuthToken}`
        }
      });
      if (respone.status == 200) {
        this.listInvoice = respone.data.data;
        this.total = respone.data.total;
      }
      loader.hide();
    },
    setPage($event){
        this.search.page = $event;
        this.loadData();
    },
    async exportExcel(){
      this.$swal
        .fire({
          title: "តើអ្នកចង់ export excel មែនទេ?",
          showCancelButton: true,
          confirmButtonText: `យល់ព្រម`,
          cancelButtonText: `បោះបង់`
        })
        .then(async (result) => {
          if (result.isConfirmed) {
              let loader = this.showLoader();
              const response = await axios.post("export-new-registration",{} ,{
                headers: {
                  Authorization: "Bearer " + this.$store.getters.getAuthToken
                },
                responseType: "blob"
              });
              const type = response.headers["content-type"];
              const blob = new Blob([response.data], {
                type: type,
                encoding: "UTF-8"
              });
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = "new-registration.xlsx";
              link.click();
              loader.hide();
          }
        });
    },
    getShow(item){
      this.currentItem = item;
      console.log('it is current item:',this.currentItem);
    }
  },
  created() {
    //this.loadData();
    this.loadyear();
  },
  mounted() {
   
  }, components: {
    Pagination
  }
};
</script>
<style scoped>

div.content {
  margin-left: 200px;
  padding: 25px;
  height: auto;
  margin-top: 0;
}

@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {
    float: left;
  }
  div.content {
    margin-left: 0;
  }
}

.footer {
  margin-left: 200px;
}
.money-text{
  font-size: 18px;
}
</style>
